module.exports = __webpack_public_path__ + "img/dianshang.805d1d9.jpg";